import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Root, classes } from './utils';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import organizationsScanHistoryColumnData from './organizationsScanHistoryColumnDef';
import { getScanHistoryDataSA } from '../../../../services/scanHistoryApi';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';

const OrganizationScanHistory = () => {
  const [gridSettingData, setGridSettingData] = useState({});
  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus(
        'organizations-scan-history',
      );
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);
  return (
    <Root className={classes.root}>
      <Box className={classes.MainBox}>
        <AgGrid
          TitleHeader="Scanning History"
          className={classes.organizationsScanHistoryAgGridStyle}
          columnData={organizationsScanHistoryColumnData}
          getRowData={getScanHistoryDataSA}
          gridSettingData={gridSettingData}
          gridKey="organizations-scan-history"
          setGridSettingData={setGridSettingData}
        />
      </Box>
    </Root>
  );
};

export default OrganizationScanHistory;
